import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#podcast", label: "Podcast" },
  { href: "#book", label: "Book" },
  { href: "#classes", label: "Classes" },
  { href: "#submit", label: "Ask" },
  { href: "#speaking", label: "Speaking" },
  { href: "#contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-slate-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-16">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-[#0369A1] text-white font-heading text-lg">
            D
          </span>
          <span className="font-heading text-lg text-slate-900 leading-none">
            Ask Chaplain <span className="text-[#D97706]">Derrick</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-slate-600 hover:text-[#0369A1] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#submit"
            data-testid="nav-cta-ask"
            className="text-sm bg-[#0369A1] hover:bg-[#0284C7] text-white rounded-full px-5 py-2 transition-colors"
          >
            Submit a Question
          </a>
        </nav>

        <button
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-slate-200 text-slate-700"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden border-t border-slate-100 bg-white"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-slate-700 py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="bg-[#0369A1] text-white rounded-full px-5 py-2 text-center"
            >
              Submit a Question
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
